






















































































import Vue from 'vue'
import mediaMixin from '../mixins/media-mixin'
import { mapGetters } from 'vuex'
import Media from '@/types/Media.interface'
export default Vue.extend({
    mixins: [mediaMixin],
    props: {
        //  Determines if our menu is disabled but still appears
        disabled: {
            type: Boolean,
            default: false
        },
        //  Determines if we place a hint on our media menu
        hint: {
            type: Boolean,
            default: false
        },
        //  The person that we are sending media to (only applicable in Inbox)
        person: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            //  Our value bound to our menu determining if it is open or closed
            open: null
        }
    },
    computed: {
        ...mapGetters({
            images: 'messageMedia',
            paginating: 'messageMediaPaginating'
        })
    },
    methods: {
        mediaScroll(event): void {
            //  Get the DOM from the event
            const content = event.target

            //  Get the height of the content
            const contentHeight = content.clientHeight

            //  Get current scroll location
            const current = content.scrollTop

            //  Determine if the scroll position is at the bottom
            const bottom = current + contentHeight >= content.scrollHeight

            //  If we are NOT at the bottom, we are done
            if (!bottom) return

            //  Else, we need to paginate
            this.paginateCurrentList()
        },
        onMediaSelected(doc: Media): void {
            this.open = false
            this.$emit('onMediaSelected', doc)
        },
        async onAddNew(event: Event): Promise<void> {
            //  Close our menu
            this.open = false

            //  Emit our uploading event
            this.$emit('uploading', true)

            //  Cast the target to an HTMLInputElement
            const target = event.target as HTMLInputElement

            //  Wait for our files change event
            const media = await this.filesChange(target.files)

            //  Emit our uploading event to stop
            this.$emit('uploading', false)

            //  Select our media
            this.$emit('onMediaSelected', media)
        },
        paginateCurrentList(): void {
            //  Grab our current page
            const current = this.$store.getters.messageMediaCurrentPage

            //  Grab the last page
            const lastPage = this.$store.getters.messageMediaLastPage

            //  Determine the next page
            const nextPage = current + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Paginate the next page
            this.$store.dispatch('messageMediaPaginate', nextPage)
        }
    }
})
